import styled from "styled-components";

export const ClearIcon = styled.span`
  font-size: 16px !important;
  position: absolute;
  right: -16px;
  top: -3px;
  color: #e95648;
  cursor: pointer;
`;